var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video",
    d: "M10.5-12a1.447,1.447,0,0,1,1.063.438A1.447,1.447,0,0,1,12-10.5v9a1.447,1.447,0,0,1-.437,1.063A1.447,1.447,0,0,1,10.5,0h-9A1.447,1.447,0,0,1,.438-.437,1.447,1.447,0,0,1,0-1.5v-9a1.447,1.447,0,0,1,.438-1.062A1.447,1.447,0,0,1,1.5-12Zm5.938,1.188a.953.953,0,0,1,1.031-.078A.92.92,0,0,1,18-10v8a.917.917,0,0,1-.547.891.922.922,0,0,1-1.016-.078L13-3.531V-8.469Z",
    transform: "translate(0 12)",
    fill: "#5d6373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.65ebca32657679ca0fc9d12a0670c059.svg";
export { ForwardRef as ReactComponent };